/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default [
	[ "όχι μόνο", "αλλά και" ], [ "όχι μόνο να μην", "αλλά ούτε και να" ], [ "από την μία", "από την άλλη" ], [ "αφενός", "αφετέρου" ],
	[ "μεν", "δε" ], [ "είτε", "είτε" ],
];
